<template>
  <div class="leaderboard-mobile is-hidden-tablet">
    <ins :class="['leaderboard__ad__mobile adsbygoogle leaderboard', { 'force-narrow' : forceNarrowAd }, { 'force-square' : forceSquareAd }]" data-ad-client="ca-pub-2580109990739065" data-ad-slot="4200499317"></ins>
  </div>
</template>

<script>
  export default {
    props: {
      wait: {
        type: Boolean,
        default: false
      },
      waitLonger: {
        type: Boolean,
        default: false
      },
      forceSquareAd: {
        type: Boolean,
        default: false
      },
      forceNarrowAd: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      record: {}
    }),
    mounted () {
      // fetch ad from api
      // if no result, display google - delayed
      if (this.waitLonger) {
        setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 1000)
      } else if (this.wait) {
        setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 800)
      } else {
        setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 500)
      }
    }
  }
</script>

<style>
  .leaderboard-mobile {
    margin: 20px auto;
  }

  .leaderboard {
    margin: 30px auto 30px auto;
  }

  .leaderboard__ad__mobile {
    display: block;
    width: 320px;
    height: 250px;
  }

  .force-narrow {
    width: 320px!important;
    height: 50px!important;
  }

  .force-square {
    width: 300px!important;
    height: 250px!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/LeaderBoardMobile.vue